export const FORM_ENDPOINT = import.meta.env.VITE_FORMS_ENDPOINT || '';
export const FORM_EMAIL_TO = import.meta.env.VITE_FORMS_EMAIL || 'catadorca@yahoo.com'; 